import PageHeader from "components/Page/PageHeader";

import DateRangePicker from "components/Input/DateRangePicker";
import { TipoDestinoEnum } from "features/documentos/enums";
import useNumeroMensagensTipoDestino from "features/mensagens/hooks/useNumeroMensagensTipoDestino";
import { ListagemAutorizacaoPortariaFiltro } from "./../hooks/useFiltro";
import { BiCog } from "react-icons/bi";

function PageHeaderPortaria({
  filtro,
  onChangeFiltro,
  onOpenParametros,
}: {
  filtro: ListagemAutorizacaoPortariaFiltro;
  onChangeFiltro: (filtro: Partial<ListagemAutorizacaoPortariaFiltro>) => void;
  onOpenParametros: () => any;
}) {
  const { data: numeroMensagens, isLoading: isLoadingNumeroMensagens } =
    useNumeroMensagensTipoDestino(TipoDestinoEnum.Portaria, 30 * 1000);

  return (
    <PageHeader
      mb="10px"
      title="Portaria"
      midComponent={
        <DateRangePicker
          onChange={(dataInicio, dataFim) => {
            onChangeFiltro({
              dataInicio,
              dataFim,
            });
          }}
          value={filtro}
        />
      }
      iconExtraButton={<BiCog />}
      extraButtonIconPosition="left"
      extraButtonTitle="Parâmetros"
      extraButtonOnClick={onOpenParametros}
      notificationButtonTitle="Ver mensagens"
      isLoadingNotificationButton={isLoadingNumeroMensagens}
      notificationButtonOnClick={() =>
        window.open(
          `${window.location.origin}/administracao/mensagens?tipoDestinoId=${TipoDestinoEnum.Portaria}`,
          "_blank"
        )
      }
      badgeNotificationButton
      badgeValueNotificationButton={`${numeroMensagens || 0}`}
    />
  );
}

export default PageHeaderPortaria;
